import { Card } from "../../freelo";
import { IConverter, TSnapshot } from "../generics";

export const cardConverter: IConverter<Card> = {
  toFirestore(card: Omit<Card, "id">) {
    return {
      humanReadableId: card.humanReadableId,
      title: card.title,
      description: card.description,
      listId: card.listId,
      boardId: card.boardId,
      assignee: card.assignee,
      additionalAssignees: card.additionalAssignees,
      reporter: card.reporter,
      labels: card.labels,
      startDate: card.startDate,
      dueDate: card.dueDate,
      createdAt: card.createdAt,
      updatedAt: card.updatedAt,
      updatedBy: card.updatedBy,
      createdBy: card.createdBy,
      archived: card.archived,
      comments: card.comments,
      progress: card.progress,
      hillProgress: card.hillProgress,
      attachments: card.attachments,
      githubBranch: card.githubBranch,
      checklists: card.checklists,
      featureRequestId: card.featureRequestId,
      bugReportId: card.bugReportId,
      studentId: card.studentId,
      cohortId: card.cohortId,
      isAssessment: card.isAssessment,
      assessmentScore: card.assessmentScore,
      assessmentFeedback: card.assessmentFeedback,
      deletedAt: card.deletedAt,
      deletedBy: card.deletedBy,
    };
  },
  fromFirestore(snapshot: TSnapshot) {
    const data = snapshot.data() as Card;
    return {
      id: snapshot.id,
      humanReadableId: data?.humanReadableId,
      title: data?.title,
      description: data?.description,
      listId: data?.listId,
      boardId: data?.boardId,
      assignee: data?.assignee,
      additionalAssignees: data?.additionalAssignees,
      reporter: data?.reporter,
      labels: data?.labels,
      startDate: data?.startDate,
      dueDate: data?.dueDate,
      createdAt: data?.createdAt,
      updatedAt: data?.updatedAt,
      updatedBy: data?.updatedBy,
      createdBy: data?.createdBy,
      archived: data?.archived,
      comments: data?.comments,
      progress: data?.progress,
      hillProgress: data?.hillProgress,
      attachments: data?.attachments,
      githubBranch: data?.githubBranch,
      checklists: data?.checklists,
      featureRequestId: data?.featureRequestId,
      bugReportId: data?.bugReportId,
      studentId: data?.studentId,
      cohortId: data?.cohortId,
      isAssessment: data?.isAssessment,
      assessmentScore: data?.assessmentScore,
      assessmentFeedback: data?.assessmentFeedback,
      deletedAt: data?.deletedAt,
      deletedBy: data?.deletedBy,
    };
  },
};
